import { UpdateWireType } from '@/types/wireTypes';
import { updateWireApi } from '@/api/v1/organization/wires/updateWireApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';

export const updateInboundWire = async (id: string, payload: UpdateWireType) => {
  try {
    const response = await updateWireApi(id, payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
